module.exports = __webpack_public_path__ + "img/login-img.2c4e63d1.png";